import Highcharts from 'highcharts';
import PatternFill from 'highcharts/modules/pattern-fill';
import chroma from 'chroma-js';

// One-time initialization of the Highcharts pattern module
PatternFill(Highcharts);

export type ChartPattern = {
  pattern: {
    path: {
      d: string;
      stroke: string;
      strokeWidth: number;
    };
    height: number;
    width: number;
  };
};

const CHART_PATTERN = {
  PATH: 'M0 5L5 0ZM6 4L4 6ZM-1 1L1 -1Z',
  STROKE: 1,
  SIZE: 5,
  COLOR_TRANSFORM: (color: string) => chroma(color).desaturate(1.5).brighten(1).hex(),
};

/**
 * Get a pattern definition object to use instead of an Highchart color
 * @param {string} color Hex color to base the pattern on
 * @returns {Object} Highcharts pattern definition object
 */
export const getChartPattern = (color: string) => ({
  pattern: {
    path: {
      d: CHART_PATTERN.PATH,
      stroke: CHART_PATTERN.COLOR_TRANSFORM(color),
      strokeWidth: CHART_PATTERN.STROKE,
    },
    height: CHART_PATTERN.SIZE,
    width: CHART_PATTERN.SIZE,
  },
});

/**
 * Maps a color array with specific Highcharts pattern, to use in a Sunburst Chart
 * @param {[string]} colors Colors array to base patterns on
 * @returns {Object} Custom Highcharts pattern definitions
 */
export const getPatternDefinitions = (colors: string[]) => {
  if (!colors.length) {
    throw new Error('No colors provided');
  }

  colors = colors.slice();
  return {
    fundType: getChartPattern(colors.shift()!),
    weight: colors.map(getChartPattern),
  };
};
